import { useSession } from '@context/sessionProvider';
import { sendDataAPI } from '@lib/sendDataAPI';
import { ConfigData, ConfigDataResponse } from '@/types';
import { toast } from '@heroui/react';
import useSWR from 'swr';
import { createFetcher } from '@lib/hooks';

type SaveSettingsResult = { id?: number };

export function useConfigSettings(tid?: number) {
	const { context } = useSession();
	const fetcherWithToken = createFetcher(context);

	const { data, error, isLoading } = useSWR<ConfigDataResponse>(tid ? [`/api/config/${tid}`] : null, fetcherWithToken, {
		refreshInterval: 0,
	});

	const saveSettings = async (payload: Partial<ConfigData>, tid?: number): Promise<SaveSettingsResult> => {
		const isEditMode = typeof tid === 'number' && Number.isInteger(tid);
		const endpoint = isEditMode ? `/api/config/${tid}` : '/api/config/create';
		const method = isEditMode ? 'PUT' : 'POST';

		const response = await sendDataAPI({ jwtToken: context }, endpoint, method, JSON.stringify(payload));
		const data = (await response.json()) as ConfigDataResponse & { data?: { id?: number } };

		const showToast = response.ok ? toast.success : toast.danger;
		showToast('Settings', {
			description: data.message,
		});

		return {
			id: !isEditMode && typeof data.data?.id === 'number' ? data.data.id : undefined,
		};
	};

	return {
		configData: data?.data,
		isLoading,
		error,
		saveSettings,
	};
}
